// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3C5IN","overflowing":"ReadFullNote_overflowing__19wGO"};